import { Component, OnInit, TemplateRef } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts/highstock';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-slide-show',
  templateUrl: './slide-show.component.html',
  styleUrls: ['./slide-show.component.css']
})
export class SlideShowComponent implements OnInit {
  modalRef: BsModalRef;
  route:string;
  index = 0;
  activeIndustryId;
  industryName = '';
  parameterIndexShowing = 0;
  parameterCount = 0;
  timePeriod = ((1000*45) * 10); //3 minute
  parameterPeriod = (1000 * 45); //30 Second
  // timePeriod = 10000;

  slideShowLatestLoader = false;
  isPaused = false;
  timeRange = 1;
  latestParameterDetail = [];
  industryDetails = [];
  industryList = [];
  slideShowCardDetails = [];
  parameterList = [];
  latestResponse = [];
  allResponse = [];
  industryDetailsLoader = false;
  industryListLoader = false;
  slideShowCardLoader = false;
  countLoader = false;
  graphPlot = true;
  currentRoute = '';
  deviceDataGraphResponse  = [];
  setIntervalPlaying;
  setIntervalPlaying2;
  slideShowCardCount = [];
  parameterAllResponse: Chart;
  userData:any = [];
  showSlide = false;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService, private modalService: BsModalService) { }

  userName;
  userLevel;
  searchField = {};
  config = {
    size: 'lg',
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: false,
    class: 'my-modal'
  };


  modalTitle = '';
  modalType = '';
  modalData = '';
  openModal(template: TemplateRef<any>, type, data) {
    if (!data || (data && !data.length)) return;
    this.modalType = type;
    this.modalData = data;
    if (type == 'total_exceedances_records') {
      this.modalTitle = 'TOTAL EXCEEDANCES (IN A WEEK)';
    } else if (type == 'monitoring_stations_records') {
      this.modalTitle = 'MONITORING STATIONS';
    } else if (type == 'parameters_monitored') {
      this.modalTitle = 'PARAMETERS MONITORED';
    } else if (type == 'exceeding_parameters_records') {
      this.modalTitle = 'EXCEEDING PARAMETERS';
    } else {
      return;
    }
    this.modalRef = this.modalService.show(template, this.config);
  }

  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      if(this.userData['access_level'] == 'industry' || this.userData['access_level'] == 'vendor'){
        // this.router.navigate(['dashboard']);
      }
    }

    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if(this.userLevel == 'industry'){
      this.searchField['industryId'] = this.userName;
    }

    if(this.userLevel == 'vendor'){
      this.searchField['vendorId'] = this.userData['id']?this.userData['id']:'';
    }
    this.currentRoute = this.router.url.replace('/', '');
    this.getIndustryList();
  }

  setDelay(list) {

    this.setIntervalPlaying = setInterval(() =>{
      this.currentRoute = this.router.url.replace('/', '');

      if(!this.isPaused && this.currentRoute == 'slideshow') {

      if (this.index < ((list.length)) ) {
        this.getIndustryDetails(list[this.index]['id']);
        this.getCardCount(list[this.index]['id'],null);
        // this.getSlideShowCardDetails(list[this.index]['id']);
        this.index++;
      } else {
        this.index = 0;
        this.getIndustryDetails(list[this.index]['id']);
        this.getCardCount(list[this.index]['id'], null);
        // this.getSlideShowCardDetails(list[this.index]['id']);
        this.index++;
      }
      }else{
        if(this.setIntervalPlaying){
          clearInterval(this.setIntervalPlaying);
          this.setIntervalPlaying = '';
        }
      }
    }, this.timePeriod);

    this.setIntervalPlaying2 = setInterval(() =>{
      this.currentRoute = this.router.url.replace('/', '');

      if(this.currentRoute == 'slideshow') {

            this.getSlideShowCardDetails(this.activeIndustryId);

      }else{
        if(this.setIntervalPlaying2){
          clearInterval(this.setIntervalPlaying2);
          this.setIntervalPlaying2 = '';
        }
      }
    }, this.parameterPeriod);
  }

  startShow(list) {
    if(list && list.length >0 ) {
      this.index = 1;
      this.setDelay(list);
    }
  }

  getIndustryDetails(industry_id){

    this.activeIndustryId = industry_id;

    this.industryDetailsLoader = true;
    this.route  = 'get-industry-details';
    const token    = localStorage.getItem('userToken');
    this.industryDetails = [];

    let data = {'industry_id':industry_id};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      this.industryDetails = response.data;
      this.industryDetailsLoader = false;
    });
  }

  getCardCount(industry_id,initiateFrom){

    this.activeIndustryId = industry_id;

    this.countLoader = true;
    this.route  = 'get-slider-card-counts';
    const token    = localStorage.getItem('userToken');
    this.slideShowCardCount = [];

    let data = {'industry_id':industry_id,'timeRange':this.timeRange, 'period':'week'};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      this.countLoader = false;
      this.slideShowCardCount = response.data;

      this.parameterIndexShowing = 0;
      this.getSlideShowCardDetails(this.activeIndustryId);
      // this.timePeriod = ((1000*10)* ((this.slideShowCardCount && this.slideShowCardCount['no_of_parameters_monitored'])?this.slideShowCardCount['no_of_parameters_monitored']:1));

      if(initiateFrom == 'init'){
        this.startShow(this.industryList);
      }


    });

  }

  getIndustryList(){

    this.industryListLoader = true;
    this.route  = 'get-industry-list';
    const token    = localStorage.getItem('userToken');
    this.industryList = [];
    this.searchField['industry_name'] = this.industryName;
    let data = {'search_fields':this.searchField};
    this._service.postRequestCreator( data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      this.industryList = response.data;
      this.industryListLoader = false;

      console.log(this.industryList);

      if(this.industryList && this.industryList[0]){
        this.showSlide = true;
        this.getIndustryDetails(this.industryList[0]['id']);
        this.getCardCount(this.industryList[0]['id'],'init');
      }else{
        this.showSlide = false;
      }

      // this.getSlideShowCardDetails(this.industryList[0]['id']);

      // this.startShow(this.industryList);

    });
  }

  setTimeRange(){
    this.getIndustryDetails(this.activeIndustryId);
    this.getCardCount(this.activeIndustryId,null);
  }

  getSlideShowCardDetails(industry_id){

    this.slideShowCardLoader = true;
    // this.route  = 'get-slide-show-card-details';
    const token    = localStorage.getItem('userToken');
    this.slideShowCardDetails = [];

    if(this.slideShowCardCount){
      let stationId = null;
      let parameterName = null;
      let previousParameterIndex = null;

      if(this.slideShowCardCount['no_of_parameters_monitored'] > this.parameterIndexShowing){
        stationId = this.slideShowCardCount['parameters_monitored'][this.parameterIndexShowing]['station_id'];
        parameterName = this.slideShowCardCount['parameters_monitored'][this.parameterIndexShowing]['paramkey'];
        previousParameterIndex = this.parameterIndexShowing;
        this.parameterIndexShowing = this.parameterIndexShowing + 1;
      }else{
        this.parameterIndexShowing = 0;
        previousParameterIndex = 0;
        stationId = this.slideShowCardCount['parameters_monitored'][this.parameterIndexShowing]['station_id'];
        parameterName = this.slideShowCardCount['parameters_monitored'][this.parameterIndexShowing]['paramkey'];
      }

    let data = {'industry_id':industry_id,'timeRange':this.timeRange, 'period':'week','station_id':stationId,'parameter_name':parameterName};

    this.getlatestResponse(data, previousParameterIndex);

    this._service.postRequestCreator(data, 'get-slide-show-card-details', token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      this.slideShowCardDetails['industry_response'] = response.data;
      this.parameterList = this.slideShowCardCount['parameters_monitored'];
      this.allResponse = response.data.industry_response;

      if(this.allResponse && Object.keys(this.allResponse).length){
        let deviceResponseRow = [];

        let dataSet = [];
        let deviceDetails =  [];
        let detailStatus = false;
        let parameterUnit = '';

        if(this.allResponse && this.allResponse[this.parameterList[previousParameterIndex]['station_id']] && this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']] ){
          for (var responseKey in this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']]) {

            if(!detailStatus) {

              detailStatus = true;
              deviceDetails['min'] = (this.allResponse && this.allResponse[this.parameterList[previousParameterIndex]['station_id']] && this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']]) ? this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']][responseKey]['min'] : '';
              deviceDetails['max'] = (this.allResponse && this.allResponse[this.parameterList[previousParameterIndex]['station_id']] && this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']]) ? this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']][responseKey]['max'] : '';
              deviceDetails['stdunit'] = ( this.allResponse && this.allResponse[this.parameterList[previousParameterIndex]['station_id']] && this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']]) ? this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']][responseKey]['unit'] : '';
              deviceDetails['label'] = (this.allResponse && this.allResponse[this.parameterList[previousParameterIndex]['station_id']] && this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']] ) ? this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']][responseKey]['parameter'] : '';
              parameterUnit = (this.allResponse && this.allResponse[this.parameterList[previousParameterIndex]['station_id']] && this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']] ) ? this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']][responseKey]['unit'] : '';
            }
            dataSet.push([Date.parse(this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']][responseKey]['date_time']),parseFloat(this.allResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']][responseKey]['value'])]);
          }
          this.deviceDataGraphResponse[0] = {'name':(parameterName && parameterName.toLowerCase() == 'ph' ? 'pH' : parameterName),'data':dataSet,'tooltip':{valueDecimals: 2}};
          this.drawResponseLineChartGraph(this.deviceDataGraphResponse,deviceDetails,'data', parameterUnit);
        }

        this.graphPlot = true;
      }else{
        this.graphPlot = false;
      }

      this.slideShowCardLoader = false;
    });

    }
  }


  getlatestResponse(data, previousParameterIndex){

    this.slideShowLatestLoader = false;
    // this.route  = 'get-slide-show-latest-details';
    const token    = localStorage.getItem('userToken');

    this._service.postRequestCreator(data, 'get-slide-show-latest-details', token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      this.slideShowCardDetails['latest_response'] = response.data;
      this.parameterList = this.slideShowCardCount['parameters_monitored'];
      this.latestResponse = response.data.latest_response;

      this.latestParameterDetail['param_name'] = (this.parameterList[previousParameterIndex] && this.parameterList[previousParameterIndex]['parameter_name'])?this.parameterList[previousParameterIndex]['parameter_name']:'NA';
      this.latestParameterDetail['min'] = (this.parameterList[previousParameterIndex] && this.parameterList[previousParameterIndex]['min']) ? this.parameterList[previousParameterIndex]['min']:0;
      this.latestParameterDetail['max'] = (this.parameterList[previousParameterIndex] && this.parameterList[previousParameterIndex]['max']) ? this.parameterList[previousParameterIndex]['max']:0;
      this.latestParameterDetail['std_unit'] = (this.parameterList[previousParameterIndex] && this.parameterList[previousParameterIndex]['stdunit']) ? this.parameterList[previousParameterIndex]['stdunit']:'NA';

      this.latestParameterDetail['value'] = (this.latestResponse[this.parameterList[previousParameterIndex]['station_id']] && this.latestResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']])?this.latestResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']]['value']:'';
      this.latestParameterDetail['response_unit'] = (this.latestResponse[this.parameterList[previousParameterIndex]['station_id']] && this.latestResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']])?this.latestResponse[this.parameterList[previousParameterIndex]['station_id']][this.parameterList[previousParameterIndex]['paramkey']]['unit']:'';
      // this.parameterCount++;
      this.slideShowLatestLoader = false;
    });

  }
  playShow() {
    this.isPaused = false;
    document.getElementById("btnPlay").style.display = "none";
    document.getElementById("btnPause").style.display = "block";
  }

  pauseShow() {
    this.isPaused = true;
    document.getElementById("btnPause").style.display = "none";
    document.getElementById("btnPlay").style.display = "block";
  }

  prevShow() {
    this.isPaused = true;
    if(this.index > 0) {
      this.index--;
    }
    this.getIndustryDetails(this.industryList[this.index]['id']);
    this.getCardCount(this.industryList[this.index]['id'],null);
    // this.getSlideShowCardDetails(this.industryList[this.index]['id']);

    this.playShow();
  }

  nextShow() {
    this.isPaused = true;

    if(this.index < ((this.industryList.length)) - 1 ) {
      this.index++;
    }else{
      this.index = 0;
    }
    this.getIndustryDetails(this.industryList[this.index]['id']);
    this.getCardCount(this.industryList[this.index]['id'],null);
    // this.getSlideShowCardDetails(this.industryList[this.index]['id']);

    this.playShow();
  }

  drawResponseLineChartGraph(deviceDataGraphResponse, deviceDetail,type, parameterUnit=null){

    let lineChartLocal = new Chart({

      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      yAxis: {
        title: {
          // visible: false,
          text: (deviceDetail.label && deviceDetail.label.toLowerCase() == 'ph' ? 'pH' : deviceDetail.label) + ' (' + (parameterUnit && parameterUnit.toLowerCase() == 'ph' ? 'pH' : parameterUnit) + ')'
        },
        plotLines: [{
          value: type == 'data'?deviceDetail.min:null,
          color: 'green',
          dashStyle: 'ShortDash',
          width: 2,
          label: {
            text: 'Prescribed Standard '+deviceDetail.min+' '+deviceDetail.stdunit
          }
        }, {
          value: type == 'data'?deviceDetail.max:1,
          color: 'red',
          dashStyle: 'ShortDash',
          width: 2,
          label: {
            text: type == 'data'?'Prescribed Standard '+deviceDetail.max+' '+deviceDetail.stdunit:'Max limit 1'
          }
        }]
      },
      xAxis: {
        visible: true,
        labels: {
          rotation:-45,
          formatter: function(){
            return moment(new Date(this.value)).format('MMM DD, HH:mm');
          },
        },
      },
      legend: { enabled: true },
      tooltip: {
        backgroundColor: '#EEF3F6',
        borderColor: 'black',
        borderRadius: 10,
        borderWidth: 1,
        formatter: function(){
          return '<b>'+ (deviceDetail.label && deviceDetail.label.toLowerCase() == 'ph' ? 'pH' : deviceDetail.label) + ' ('+ parameterUnit + ')' + ':</b> ' + this.y + '<br/><b>Time:</b> ' + moment(new Date(this.x)).format('DD MMM YYYY HH:mm');
        }
      },
      credits: {
        enabled: false
      },
      series: deviceDataGraphResponse,
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500

          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    });
    this.parameterAllResponse = lineChartLocal;
  }

}
